module.exports = {
    sanity: {
      projectId: 'x5pgqc2x',
      dataset: 'production',
    },
  };
  